import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { AuthService } from '@fry/lib/auth';
import { BookingAvailableItemsSearch } from './booking-available-items.search';
import { BookingOptionsStore } from '@fry/booking/lib/booking-items/booking-options.store';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { ListDefaults, ListService, ListStateLoading } from '@fry/lib/list';
import { NotifyService } from '@fry/lib/utils';

import { BookingItem } from '@fry/booking/lib/booking-items';

@Component({
    selector: 'eas-booking-available-items-list',
    templateUrl: './booking-available-items-list.component.html',
    providers: [
        BookingAvailableItemsSearch,
        BookingOptionsStore,
        ListService,
    ],
    standalone: false
})
export class BookingAvailableItemsListComponent implements OnInit, OnDestroy {

  public actions: EASLinkAction[] = [
    {
      type: 'link',
      label: $localize `Back to available bookings`,
      condition: () => of(true),
      link: of(['/bookings/available']),
      color: 'primary',
    }
  ];
  public items = this.list.items;

  path: string[];

  public get subtitle(): string {
    if (this.path.length === 0) { return undefined; }

    return this.store.breadcrumbs.reduce((acc, item) => {
      acc = item instanceof BookingItem
            ? `${item.orig.name}`
            : `${acc} / ${item.orig['title']}`;
      return acc;
    }, '');
  }

  constructor(
    private auth: AuthService,
    private list: ListService,
    private notify: NotifyService,
    private route: ActivatedRoute,
    private search: BookingAvailableItemsSearch,
    private store: BookingOptionsStore
  ) {

  }

  ngOnInit() {
    // Get query parameters
    this.route.queryParamMap.pipe(
      switchMap(params => {
        const parameter = params.get('path') as string;
        this.path = parameter ? parameter.split(',') : [];
        return this.load();
      })
    ).subscribe(
      () => {},
      (error) => this.notify.error(error)
    );
  }

  load() {
    // WIP: Not sure if this is good idea...
    this.list.state.next(ListStateLoading);

    const defaults: ListDefaults = {
      searchModel: { filter: {eligible: true}, sort: {sort_on: 'title', sort_order: 'asc'}},
      pageSize: 20,
    };

    // Preserve eligible option
    if (this.list.searchModel && this.list.searchModel.filter) {
      defaults.searchModel.filter.eligible = this.list.searchModel.filter.eligible;
    }

    this.list.reset();
    this.list.resetFilter();
    return this.getUsername().pipe(
      tap(username => {
        this.store.searchParameters = { user: username, path: this.path };
        this.store.reset();
      }),
      switchMap(() => this.list.setupWith(this.store, this.search, undefined, defaults)),
    );
  }

  private getUsername() {
    const user = this.route.snapshot.paramMap.get('user');
    if (user) {
      return of(user);
    }

    return this.auth.currentUser().pipe(
      map(current => current.username)
    );
  }

  ngOnDestroy() { }

}
